import { FieldsEnum, FormsEnum } from 'app/shared/enums';
import {
  getQuotationIsFromRenewal,
  setDataOwnersChangedRenewal,
  setQuestionVisibility,
  changeQuestionClearOnHide,
} from 'app/services/businessFunctionHelpers';

export function handleOnChangeDataSecondCoOwnerRenewal(initialRun?: boolean) {
  const isFromRenewal = getQuotationIsFromRenewal();

  if (isFromRenewal && !initialRun) {
    setDataOwnersChangedRenewal({
      ownerName: 'secondCoOwner',
      isChanged: true,
    });

    changeQuestionClearOnHide(
      FieldsEnum.Coowners2LicenseYear,
      FormsEnum.CalculationForm,
      true
    );
    changeQuestionClearOnHide(
      FieldsEnum.Coowners2LicenseMonth,
      FormsEnum.CalculationForm,
      true
    );
    changeQuestionClearOnHide(
      FieldsEnum.Coowners2NoDrivingLicense,
      FormsEnum.CalculationForm,
      true
    );
    setQuestionVisibility({
      key: FieldsEnum.Coowners2LicenseYear,
      visible: true,
      formName: FormsEnum.CalculationForm,
    });

    setQuestionVisibility({
      key: FieldsEnum.Coowners2NoDrivingLicense,
      visible: true,
      formName: FormsEnum.CalculationForm,
    });
  }
}
